
export const infiniteRollAnimation = () => {
    const animations = Array.from(document.querySelectorAll('.infinite-roll-animation'));

    if (animations) {
        animations.forEach(animation => {
            const animationContent = animation.innerHTML;
            animation.innerHTML += animationContent + animationContent;
        })
    }
}